import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getFunctions } from 'firebase/functions';

// Firebase-Konfiguration mit Fallback-Werten
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBqPRmuSWO74HYerxuM-2aQCcPSR3rUBYc",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "cards-against-humanity-o-67272.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "cards-against-humanity-o-67272",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "cards-against-humanity-o-67272.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "112248377962",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:112248377962:web:eb0dace85508bc31293013",
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || "https://cards-against-humanity-o-67272-default-rtdb.europe-west1.firebasedatabase.app",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-M3749R33JJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const rtdb = getDatabase(app);
const functions = getFunctions(app);

// Initialize Analytics only if supported and in browser
let analytics: any = null;
if (typeof window !== 'undefined') {
  isSupported().then(yes => {
    if (yes) {
      analytics = getAnalytics(app);
    }
  }).catch(console.warn);
}

export { app, analytics, db, auth, rtdb, functions }; 